





import prismicDOM from 'prismic-dom'

export default {
    name: 'DocumentLink'

    props: ['field']

    computed: 
        linkComponent: ->
            if not @field then return

            url = '#'
            target = if @field.target then 'target="\'#{this.field.target}\'" rel="noopener"' else ''
            template = ''

            if @field.url?
                url = @field.url
            else if @field.uid?
                url = prismicDOM.Link.url @field, @$prismic.linkResolver
            else
                url = '#'

            if @field.link_type is 'Document'
                template =
                    """
                        <router-link to='#{url}' #{target}>
                            <slot />
                        </router-link>
                    """
            else
                template =
                    """
                        <a href='#{url}' #{target}>
                            <slot />
                        </a>
                    """

            template: template
}
